/**
 * R7b: the smallest set of R7a's surface tests the Voice gate needs, copied
 * from packages/pipeline/src/voiceSurface.ts. The gate must measure a draft
 * the SAME way R7a measured the owner's lines, or the comparison means
 * nothing. That module is not exported through the pipeline package's index
 * and R7b may not touch packages/pipeline, so the copy lives here.
 * packages/agents/src/voiceSurfaceCopy.test.ts pins the two copies equal, by
 * behaviour through `buildVoiceFromLines` and by regex source. Exporting the
 * pipeline module and deleting this copy is the better end state (F-16, one
 * shared module); it is R7a's file to change.
 */

/** Opener classes, identical to the pipeline's `OpenerClass`. */
export type SurfaceOpenerClass = "greeting" | "greeting+name" | "name" | "direct";

/** R5's emoji test, the one definition. */
export const surfaceHasEmoji = (text: string): boolean => /\p{Extended_Pictographic}/u.test(text);

/** Runs of "?", so "??" is one question. */
export const surfaceQuestionCount = (text: string): number => (text.match(/\?+/g) ?? []).length;
/** Runs of "!", so "!!!" is one exclamation. */
export const surfaceExclamationCount = (text: string): number => (text.match(/!+/g) ?? []).length;

/** Where a customer's name stood: a stage 0 redaction or the model-side `CUST_` pseudonym. */
export const SURFACE_PSEUDONYM_TOKEN_RE = /\bCUST_\d{4,}\b|\[REDACTED_(NAME|HANDLE)\]/;
export const SURFACE_GREETING_RE =
  /^(hi+|hey+|hello+|hiya|heya|yo|howdy|greetings|dear|good\s+(morning|afternoon|evening)|morning|evening)\b/i;

/** Greeting word first, the pseudonym within the first three words, both, or neither. */
export function surfaceOpenerClass(text: string): SurfaceOpenerClass {
  const t = text.trim();
  const greeting = SURFACE_GREETING_RE.test(t);
  const name = SURFACE_PSEUDONYM_TOKEN_RE.test(t.split(/\s+/).slice(0, 3).join(" "));
  if (greeting && name) return "greeting+name";
  if (greeting) return "greeting";
  if (name) return "name";
  return "direct";
}
